import React from 'react';

function Overview() {
  return (
    <div className="overview-container">
      {/* Overview content will go here */}
    </div>
  );
}

export default Overview;
